import * as types from './mutation-types'

export default {
  [types.LOAD_SHOP_COUNT_STATS](state, data) {
    state.countStats = data
  },
  [types.LOAD_SHOP_ADVANCED_COUNT_STATS](state, data) {
    state.advancedCountStats = data
  },
  [types.LOAD_SHOP_DATA_STATS](state, data) {
    state.dataStats = data
  },
  [types.LOAD_SHOP_CATEGORY_STATS](state, data) {
    state.categoryStats = data
  },
  [types.LOAD_SHOP_CUSTOMER_STATS](state, data) {
    state.customerStats = data
  },
  [types.LOAD_SHOP_SALE_STATS](state, data) {
    state.saleStats = data
  },
  [types.LOAD_SHOP_BEST_DAY_STATS](state, data) {
    state.bestDayStats = data
  },
  [types.SET_LOADING](state, loading) {
    state.loading = loading
  }
}
